import { render, staticRenderFns } from "./BackgroundSize.vue?vue&type=template&id=4c1c051c&"
import script from "./BackgroundSize.vue?vue&type=script&lang=js&"
export * from "./BackgroundSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports